const wrapElement = (className) => {
  const ref_tag = document.querySelector(className);

  if (!ref_tag) return false;

  const ref_tag_container = ref_tag.closest(".fullwidth-content > div");

  if (ref_tag_container && !ref_tag_container.classList.contains("denhaag-openstad-wrapper")) {
    const openstad_element_wrapper = document.createElement("div");
    openstad_element_wrapper.className = "denhaag-container denhaag-openstad-wrapper";
    ref_tag_container.parentNode.insertBefore(openstad_element_wrapper, ref_tag_container);
    openstad_element_wrapper.appendChild(ref_tag_container);
  }

  return true;
}

export const extendOpenstadShortcode = (className) => {
  // Only run on pages that have the OpenStad shortcode.
  const openstadContainer = document.querySelector(".openstad");
  if (!openstadContainer) return;

  // Try immediately in case the element already exists.
  if (wrapElement(className)) return;

  // Otherwise, observe only the OpenStad container for changes.
  const observer = new MutationObserver((mutations, obs) => {
    if (wrapElement(className)) {
      obs.disconnect();
    }
  });

  observer.observe(openstadContainer, {
    childList: true,
    subtree: true,
  });
}